import { render } from "./MessageComponent.vue?vue&type=template&id=21ef38f2&scoped=true"
import script from "./MessageComponent.vue?vue&type=script&lang=js"
export * from "./MessageComponent.vue?vue&type=script&lang=js"

import "./MessageComponent.vue?vue&type=style&index=0&id=21ef38f2&scoped=true&lang=css"

import exportComponent from "/home/nicky/htdocs/vuejs-tailwindcss-project/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-21ef38f2"]])

export default __exports__